import { endPoints, requestType } from "../constants/variables";
import Api from "./index";

const callBackRequest = (payload) => {
  return Api(endPoints.callBackRequest, payload, requestType.POST);
};

const callBackRequestDevelopment = (payload) => {
  return Api(endPoints.callBackRequestDevelopment, payload, requestType.POST);
};

export { callBackRequest, callBackRequestDevelopment };
